import { useState, useEffect } from 'react';

export default function useDelayedRender(delay: number): <T>(fn: () => T) => T | null {
  const [delayed, setDelayed] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setDelayed(false), delay);
    return () => clearTimeout(timeout);
  }, [delay]);

  return (fn) => (delayed ? null : fn());
}
